"use client"

import { useTranslation } from "react-i18next"

type PolicyName = "termsOfService" | "privacyPolicy" | "cookiePolicy" | "aiNotice"

type PolicySection = {
  heading: string
  paragraphs?: string[]
  items?: string[]
}

export function PolicyPage({ policy }: { policy: PolicyName }) {
  const { t } = useTranslation("legal")
  const sections = t(`policies.${policy}.sections`, { returnObjects: true }) as PolicySection[]

  return (
    <div className="container mx-auto min-h-screen bg-white px-4 py-12">
      <h1 className="mb-8 text-4xl font-bold text-midnight-blue">{t(`policies.${policy}.title`)}</h1>
      {sections.map(section => (
        <section key={section.heading} className="mb-8">
          <h2 className="mb-4 text-2xl font-semibold text-electric-teal">{section.heading}</h2>
          {section.paragraphs?.map(paragraph => (
            <p key={paragraph} className="mb-4 leading-relaxed text-charcoal">
              {paragraph}
            </p>
          ))}
          {section.items && (
            <ul className="list-inside list-disc space-y-2 leading-relaxed text-charcoal">
              {section.items.map(item => <li key={item}>{item}</li>)}
            </ul>
          )}
        </section>
      ))}
      <p className="mt-12 text-sm text-gray-500">{t(`policies.${policy}.lastUpdated`)}</p>
    </div>
  )
}